import React from 'react';

import { Home } from '@pages/Home';
import { Profile } from '@pages/Profile';
import { Education } from '@pages/Education';
import { Experience } from '@pages/Experience';

import { NavMenu } from '@components/NavMenu';

export const AppRouter = () => (
  <NavMenu>
    <Home />
    <Experience />
    <Education />
    <Profile />
  </NavMenu>
);
